import { hasIn, includes, join } from 'lodash';
const configHelper = require('../../config/index');

const checkResponseStatus = (response) => {
    if (response.status >= 400 && response.status < 600) {
        const errorMessage = hasIn(response, 'statusText')
            ? response.statusText
            : 'Bad response from server';
        console.error(errorMessage);
        return;
    }
    return response;
};

const elaborateResponse = (response) =>
    includes(response.headers.get('Content-Type'), 'application/json')
        ? response.json()
        : response;

const getVideos = (id, maxWidth, youTubeApiKey) => {
    return fetch(
        `https://youtube.googleapis.com/youtube/v3/videos?part=snippet%2Cplayer%2CcontentDetails&id=${id}&maxWidth=${maxWidth}&key=${youTubeApiKey}`,
        {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' },
        }
    )
        .then((r) => checkResponseStatus(r))
        .then((r) => elaborateResponse(r));
};

export { getVideos };
